import React from "react";

// KPCell component: displays 8 rows of short text, no borders
import PropTypes from "prop-types";

function KPCell({ items }) {
return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", padding: 4 }}>
        {items.dataPoints?.map((dataPoint, idx) => (
            <div
                key={idx}
                style={{
                    fontSize: dataPoint.type === 2 ? 15 : 14,
                    fontWeight: "bolder",
                    padding: "2px 0",
                    width: "100%",
                    textAlign: "left",
                    paddingLeft: dataPoint.type === 1 ? 12 : undefined,
                    color: "#000"
                }}
            >
                {dataPoint.text}
            </div>
        ))}
    </div>
);
}

KPCell.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  chatInfo: PropTypes.any,
};

HCViewKPChart.propTypes = {
  bhavaChartData: PropTypes.any,
  chatInfo: PropTypes.any,
};

export default function HCViewKPChart({bhavaChartData, chatInfo}) {
  // Map KPCell data to the 12 surrounding cells
  // Table cell order: top row left to right, then right column top to bottom, then bottom row right to left, then left column bottom to top
  const cellOrder = [0,1,2,3,4,5,6,7,8,9,10,11];
  // Table layout: 4x4
  // Indices for KPCell: [0,1,2,3] (top row), [4] (right col), [5,6,7] (bottom row), [8] (left col)
  // But for merged center, we need to place KPCells in the correct positions

  // Helper to render a cell with KPCell or merged center
  function renderCell(row, col) {
    // Center 4 cells (rows 1-2, cols 1-2) are merged
    if (row === 1 && col === 1) {
    return (
      <td rowSpan={2} colSpan={2} style={{ textAlign: "center", border: "2px solid #000", verticalAlign: "middle", background: "#f5f7fa" }}>
        <div style={{ minHeight: 150, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontWeight: 600, fontSize: 18 }}>
          <div style={{ fontSize: 24 }}>{chatInfo.rashi}</div>
          <div style={{ fontSize: 18 }}>{chatInfo.place}</div>
          {/* <div style={{ fontSize: 16 }}>{chatInfo.dateTime}</div> */}
          <div style={{ fontSize: 14 }}>{chatInfo.longitude} {chatInfo.latitude}</div>
        </div>
      </td>
    );
    }
    // Hide the other 3 center cells
    if ((row === 1 && col === 2) || (row === 2 && col === 1) || (row === 2 && col === 2)) {
      return null;
    }

      return <td style={{ minHeight: 150, width: "25%", height: 60, verticalAlign: "top", border: "2px solid #000" }}>
          <KPCell items={getChatCellData(bhavaChartData, row, col)} />
      </td>;
  }

return (
    <div style={{ maxWidth: 600, margin: "0 auto", overflowX: "auto" }}>
        <table
            style={{
                width: "600px",
                height: "600px",
                border: "2px solid #000",
                borderCollapse: "collapse",
                tableLayout: "fixed",
                boxShadow: "0 2px 8px #eee",
                borderRadius: 8,
            }}
        >
            <tbody>
                {[0, 1, 2, 3].map((row) => (
                    <tr key={row} style={{ height: "25%" }}>
                        {[0, 1, 2, 3].map((col) =>
                            // Each cell gets a border
                            renderCell(row, col)
                                
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
}

function getChatCellData(bhavaChartData, row, col) {
    // Map 4x4 grid positions to bhavaChartData indices for KP cells
    // Top row: [11, 0, 1, 2]
    if (row === 0) return bhavaChartData[[11, 0, 1, 2][col]];
    // Right column: [3, 4] (row 1,2 col 3)
    if (col === 3 && (row === 1 || row === 2)) return bhavaChartData[2 + row];
    // Bottom row: [8, 7, 6, 5]
    if (row === 3) return bhavaChartData[8 - col];
    // Left column: [10, 9] (row 1,2 col 0)
    if (col === 0 && (row === 1 || row === 2)) return bhavaChartData[11 - row];
    return [];
}

